import React from 'react';
import { BsInstagram, BsLinkedin, BsYoutube } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app_social'>
      <div>
        <a href="https://instagram.com/kaushal_7__" target="_blank" rel="noreferrer">
          <BsInstagram />
        </a>
      </div>
      <div>
        <a href="https://linkedin.com/in/kaushalbikramgajmer" target="_blank" rel="noreferrer">
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://github.com/KaushallB" target="_blank" rel="noreferrer">
          <FaGithub />
        </a>
      </div>
      <div>
        <a href="https://youtube.com/@kaushalbikramgajmer" target="_blank" rel="noreferrer">
          <BsYoutube />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
